<div class="container-idle">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>Creación de Eventos</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="close.emit(false)"></i></h1>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col form-group">
							<label for="name" class="form-label">Nombre Esquema <span class="required">*</span></label>
							<input type="text" placeholder="Ingresa el nombre del esquema" name="name" id="name"
								[(ngModel)]="newEvent.event" class="form-control">
						</div>
						<div class="col form-group">
							<label for="startDate" class="form-label">Fecha Inicio <span
									class="required">*</span></label>
							<input type="date" name="startDate" id="startDate"
								[(ngModel)]="newEvent.startDate" class="form-control">
						</div>
					</div>
					<div class="row">
						<div class="col form-group">
							<label for="endDate" class="form-label">Fecha Final <span
									class="required">*</span></label>
							<input type="date" name="endDate" id="endDate"
								[(ngModel)]="newEvent.endDate" class="form-control">
						</div>
						<div class="col form-group">
							<label for="multiplier" class="form-label">Multiplicador <span
									class="required">*</span></label>
							<input type="number" placeholder="Multiplicador" name="multiplier" id="multiplier"
								[(ngModel)]="newEvent.multiplier" class="form-control">
						</div>
					</div>
					<p class="text-muted" style="margin-top: 1em; font-size: 0.8em; text-align: right;"><i
							class="fa fa-circle-info"></i>Completa los campos marcados con un <span
							class="required">*</span> para guardar los cambios</p>
				</div>
				<div class="modal-footer">
					<button class="btn btn-success"
						[disabled]="loading || !newEvent.event || !newEvent.startDate || !newEvent.endDate || !newEvent.multiplier"
						(click)="create()">
						<ng-container *ngIf="!loading">
							<i class="fa fa-floppy-disk"></i>
						</ng-container>
						<ng-container *ngIf="loading">
							<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
							<span role="status"></span>
						</ng-container>GUARDAR
					</button>
				</div>
			</div>
		</div>
	</div>
</div>